/**
 * Account Opening Multi-language by Page
 * Mainland account opening starts with cn
 * Hong Kong account opening starts with hk
 * Common pages are extracted by page
 * Each page adds a new object
 */
export default {
    pageTitle: 'Fosun International Securities Account Opening',
    复星国际证券开户: 'Fosun International Securities Account Opening',
    // Common
    backStep: 'Back',
    nextStep: 'Next',
    submit: 'Submit',
    input: 'Please enter',
    'input{0}': 'Please enter {0}',
    select: 'Please select',
    'select{0}': 'Please select {0}',
    reset: 'Reset',
    success: 'Done',
    Understood: 'Understood',
    service: 'Contact Customer Service',
    confirmText: 'Confirm',
    returnText: 'Return to Modify',
    tip: 'Reminder',
    noAllowEmpty: 'Cannot be empty',
    confirm: 'Confirm',
    determine: 'Confirm',
    cancel: 'Cancel',
    yes: 'Yes',
    no: 'No',
    thsTip: 'You have an unfinished account opening process, please use a browser to access the link below to continue.',
    organTip: 'This phone number is linked to a trading account. Online trading for this type of account will be available soon!',
    know: 'Got it',
    音频加载中: 'Audio Loading',
    音频加载失败: 'Audio Loading Failed',
    下载星财富APP: 'Download Star Wealth APP',
    ts: 'Tip',
    // ID Card Page
    idCard: {
        title: 'ID Card Verification',
        des: 'ID info is only for account opening, we will strictly protect your privacy.',
        positive: 'Upload ID Front',
        negative: 'Upload ID Back',
        negativeMO: 'Upload ID Back (Macau)',
        photoTips: {
            title: 'Photo Tips',
            des: 'Ensure the ID border is complete, text is clear, and lighting is even without glare.',
        },
        photoError: {
            standard: 'Standard',
            missing: 'Border Missing',
            vague: 'Blurry Info',
            reflex: 'Glare',
        },
        chinaName: 'Chinese Name',
        pyName: 'Name in Pinyin',
        idCardNumber: 'ID Card Number',
        address: 'Residential Address',
        signing: 'Issuing Authority',
        period: 'Validity Period',
        long: 'Long-term',
        birth: 'Date of Birth',
        birthplace: 'Place of Birth',
        addressAlikeCM: 'Residential address same as mailing address',
        notAlikeAddressTip: 'If different, contact customer service for offline account opening.',
        max65Befor: 'Users aged 65+ please',
        max65After: 'open account offline.',
        min18: 'Users under 18 are not supported.',
        errAccount: 'ID validity less than 6 months, please update ID before applying.',
        ywxm: 'English Name',
        xing: 'Surname',
        ming: 'Given Name',
        sfzsyyxq: 'Recognition failed, please upload a clear ID photo with complete border.',
        sfzyxqbhf: 'Invalid ID validity, please reupload.',
        sfzbwz: 'ID unclear or border incomplete, please reupload.',
        sfzfyj: 'Not original or official ID, please reupload.',
        sfzfg: 'ID glare, please reupload.',
        qqryxxxyzjwqyz: 'Confirm info matches ID to avoid delays.',
        zjhm: 'ID Number',
        xmpy: 'Name in Pinyin',
        qzysfdyz: 'Note homophones',
        zzdz: 'Residential Address',
        gsfzykhhsqkh: 'This ID is already registered, please log in with the original account.',
        sjh: 'Phone Number',
        rgnwjyzhdmm: 'If you forgot the password, use the phone number to reset. For help, please',
        zgdlshs: 'Shanghai',
        changqi: 'Long-term',
        dlsfzzm: 'ZM-Mainland-ID-Front',
        dlsfzfm: 'FM-Mainland-ID-Back',
        polyphoneWarnText: 'Your name has homophones, please confirm spelling to avoid issues.',
        qscsfzjrxm: 'Please upload the front of ID card',
        qsczfzgh: 'Please upload the back of ID card',
    },
    // Bank Card
    bankCard: {
        yhkyz: 'Mainland UnionPay Card Verification',
        yhkyzDesc: 'Please upload your Hong Kong/Macau or overseas ID photo',
        yhkyzDesc1: 'Mainland cards are only used for identity verification, not for出入金。',
        qsrhsmyhh: 'Enter/scan Mainland UnionPay card number',
        bankCardNum: 'Bank Card Number',
        qsryhylsjh: 'Enter bank reserved phone number',
        phoneNumber: 'Bank Reserved Phone',
        yhylsjhmbnwk: 'Bank reserved phone cannot be empty',
        qsrnddzyxdz: 'Enter your email address',
        emailAddress: 'Email Address',
        jdjsfs: 'Statement Delivery',
        email: 'Email',
        jdyy: 'Statement Language',
        ftzw: 'Traditional Chinese',
        dzyxyyjsjddzqywdyjtz: 'Email for statements, please confirm.',
        dzyx: 'Email',
        qsrzqddzyxdz: 'Enter valid email address',
        dlkhyhk: 'Mainland-Account Opening Bank Card',
        yhksbcw: 'Verification failed, please retry with a different phone or card.',
        bankOcrError: 'Bank card recognition failed',
    },
    // Job Status
    jobStatus: {
        xxhyx: 'Primary or below',
        zhongxue: 'Secondary',
        ykhzsxy: 'Pre-U or College',
        dx: 'University',
        sshys: 'Master or above',
        sg: 'Employed',
        zg: 'Self-employed',
        tx: 'Retired',
        xs: 'Student',
        wy: 'Unemployed',
        nlmy: 'Agriculture',
        nlmyy: 'Agriculture, Forestry, Fishing',
        gyjz: 'Industry/Construction',
        cky: 'Mining',
        zzy: 'Manufacturing',
        jzy: 'Construction',
        dlrlrqjsqschgy: 'Utilities',
        jrsy: 'Finance/Commerce',
        jry: 'Finance',
        fdcy: 'Real Estate',
        pfhlsy: 'Wholesale/Retail',
        zlhsfwy: 'Leasing/Business Services',
        zshcyy: 'Accommodation/Catering',
        xxjskx: 'IT/Science',
        xxcsrjxx: 'IT/Software',
        kxyjhjsfw: 'R&D/Tech Services',
        ggshjt: 'Public/Social/Transport',
        jtyscchyz: 'Transport/Warehousing/Postal',
        jy: 'Education',
        slhjhggssgly: 'Water/Environment/Public Facilities',
        wshshgz: 'Health/Social Work',
        whtyyl: 'Culture/Sports/Entertainment',
        ggglhshbz: 'Public Admin/Social Security',
        jmfwxlother: 'Resident Services/Repair/Others',
        guoji: 'International',
        guojizuzhi: 'International Org',
        gaoguan: 'Executive',
        zhongceng: 'Middle Management',
        chujiguanli: 'Junior Management',
        putongyuangong: 'Staff',
        hehuoren: 'Partner',
        faren: 'Legal Person',
        zongjinli: 'General Manager',
        shaoyuyinian: 'Less than 1 year',
        yidaoliangnian: '1-2 years',
        sandaowunian: '3-5 years',
        liudaojiunian: '6-9 years',
        shinianyishang: '10+ years',
        jiating: 'Family',
        jianzhixinjin: 'Part-time Income',
        zujin: 'Rent',
        tuixiujin: 'Pension',
        fdctzsy: 'Real Estate Investment',
        jrsctzsy: 'Financial Market Investment',
        qtlwbc: 'Other Income',
        zyzk: 'Job Status',
        zyzkDesc: 'Collect the following information according to regulatory requirements.',
        qxzzgxl: 'Select Highest Education',
        zgxl: 'Highest Education',
        qxzzyzt: 'Select Job Status',
        zyzt: 'Job Status',
        selectGs: 'Select Company',
        qsrgswzmc: 'Enter Company Name',
        qsrgsWZmcPlaceholder: 'Enter full company name',
        gsmc: 'Company Name',
        qsrbgsdzxx: 'Enter Office Address',
        bgsdz: 'Office Address',
        qxzhy: 'Select Industry',
        hangye: 'Industry',
        qxzzy: 'Select Position',
        zhiwei: 'Position',
        qxzgznq: 'Select Work Duration',
        gznq: 'Work Duration',
        tzzjlydx: 'Investment Source',
        cwzk: 'Debt Status',
        wzw: 'No Debt',
        fd: 'Mortgage',
        qtzw: 'Other Debt',
        brwzwjf: 'No Debt Disputes',
        yzwjfzbzckh: 'Debt disputes, contact customer service for offline account opening.',
        xzhy: 'Select Industry',
        ylj: 'Understood',
        xxBefor: 'Highest education primary or below, please',
        xxAfter: 'open account offline.',
        lxkf: 'Contact Customer Service.',
        inputCompanyInfo: 'Enter Company Info',
        SamePrompt: 'Office address same as company name, please re-enter.',
        CompanyAddressTip: 'Enter full address: city, district, street, building, floor, room.',
    },
    // Finance
    Finance: {
        zyzkDesc: 'Collect the following information according to regulatory requirements.',
        xjywsr: 'Salary/Business Income',
        grcx: 'Personal Savings',
        zcjc: 'Inheritance',
        tzsy: 'Investment Income',
        zczs: 'Asset Resale',
        '20wanyixia': 'Below 200k',
        '20wandao50wan': '200k-500k',
        '50wandao100wan': '500k-1M',
        '100wandao500wan': '1M-5M',
        '500wandao1000wan': '5M-10M',
        '1000wanyishang': 'Above 10M',
        '100wanyixia': 'Below 1M',
        // v2 net assets/investable amount (aligned with risk assessment)
        '250wanyixia': 'Below 2.5M',
        '250wandao500wan': '2.5M-5M',
        '500wandao800wan': '5M-8M',
        '800wandao1500wan': '8M-15M',
        '1500wandao4000wan': '15M-40M',
        '4000wandao8000wan': '40M-80M',
        '8000wanyishang': 'Above 80M',
        '500wandao700wan': '5M-7M',
        '700wandao1000wan': '7M-10M',
        '100wandao300wan': '1M-3M',
        '300wandao500wan': '3M-5M',
        cwzk: 'Financial Status',
        zjly: 'Investment Source',
        qxzqnsr: 'Select Annual Income (HKD)',
        qnsr: 'Annual Income (HKD)',
        qxzjzc: 'Select Net Assets (HKD)',
        jzc: 'Net Assets (HKD)',
        qxzkyztzdldzc: 'Select Investable Amount (HKD)',
        kyztzdldzcjz: 'Investable Amount (HKD)',
        qxzmnpjtzje: 'Select Avg Annual Investment (HKD)',
        mnpjtzje: 'Avg Annual Investment (HKD)',
        zzlb: 'Residence Type',
        jzcbysykytzdldzc: 'Net assets should not be less than investable amount.',
        lxkf: 'Contact Customer Service.',
        sushe: 'Dormitory',
        yjrtz: 'Living with Family',
        zufang: 'Renting',
        anjiewuye: 'Mortgaged Property',
        zizhiwuye: 'Owned Property (No Mortgage)',
        zigui: 'Self-employed',
        shougu: 'Employed',
        wuzhaiwu: 'No Debt',
    },
    // Investment Experience
    Investment: {
        ynyx: 'Less than 1 year',
        yzhiwunian: '1-5 years',
        liuzhishinian: '6-10 years',
        shinianyishang: '10+ years',
        baoben: 'Capital Protection',
        zczz: 'Capital Appreciation',
        gxhb: 'Dividend',
        duichong: 'Hedging',
        tl: 'Arbitrage',
        touji: 'Speculation',
        wyyjxyspmm: 'I intend to trade derivatives',
        wwyjxyspmm: 'I do not intend to trade derivatives',
        jrjgjbdyspjz: 'Derivatives seminars by financial institutions.',
        jyjgjbyspwskc: 'Derivatives courses by educational institutions.',
        yhxtgs: 'Bank/Trust',
        zqqhqq: 'Securities/Futures/Options',
        jjzgjz: 'Fund/Asset Mgmt/Family Office',
        jysjrhyxh: 'Exchange/Financial Assoc',
        bxgs: 'Insurance',
        ysqz: 'Warrants',
        nxz: 'Callable Bull/Bear',
        qhhqq: 'Futures and Options',
        gpggpj: 'Equity-Linked Notes',
        yq: 'Forwards',
        dqhh: 'Swaps',
        tzjy: 'Investment Experience',
        gptzjy: 'Hong Kong Listed Stocks',
        jytzjy: 'Gold/Silver',
        whjsptzjy: 'Forex/Commodities',
        agtzjy: 'A-Shares',
        jjtzjy: 'Funds',
        tzmddx: 'Investment Purpose',
        khxys: 'Client Agreement',
        wyjxyspmm: 'No intention to trade derivatives',
        yyjxyspmm: 'Intend to trade derivatives',
    },
    Derivative: {
        yspmm: 'Derivatives Trading?',
        nsfljyscpdzytcjfx: 'Do you understand the main features and risks of derivatives?',
        wmbybyscpdzytzqlj: 'I understand the main features and risks of derivatives.',
        nxyzsyyyxyscpxgjy: 'You need at least one derivative-related experience (Multiple)',
        wcjsygjsyscpzxzjfxdpxhkc: 'I have attended derivative-related training or courses.',
        wxshgwdgzjyywyyscpyg: 'My current or past work/business is related to derivatives.',
        wxshgwdgzjyywyyscpygyqxgzy: 'My current or past work/business is related to derivatives. Related roles and nature:',
        wxshgwdyyscpygdgzjyywdfwnqw: 'My current or past derivative-related work/business duration:',
        wymmyscpdjymmgdyscps: 'I have traded derivatives. Traded derivatives:',
        yscpbkdbxyysqcnxzgpzsqh:
            'Derivatives include but are not limited to warrants, callable bull/bear, equity/index futures and options, commodity structured products, and ETFs, whether traded on an exchange or not.',
        nyqrwytzyscpbckh: 'You have confirmed no intention to trade derivatives, this account will not have derivative trading permissions.',
    },
    selectAccount: {
        xzzh: 'Select Account',
        zqzhlx: 'Securities Account Type',
        jinjinzh: 'Wealth Account',
        shichangleixing: 'Market Type',
        yiliaojie: 'Understood',
        xinjinzhanghu: 'Cash Account:',
        sybrzyzjjxjy: 'Use own funds for cash trading, no margin or short selling allowed.',
        rzzh: 'Margin Account:',
        ycbzjzhhmzzh: 'Also known as margin or leveraged account. Allows margin trading.',
        rongzi: 'Margin',
        sztggzhxfxhljr:
            'Borrow funds from Fosun International Securities to buy stocks, amplifying returns and risks. Choose based on your risk tolerance.',
        ktlczhh: 'Opening a wealth account allows you to buy OTC funds and bonds; otherwise, you cannot.',
        rzzhanghu: 'Margin Account',
        xianjinzhanghu: 'Cash Account',
        ganggu: 'Hong Kong Stocks',
        meigu: 'US Stocks',
        hushengangtong: 'Stock Connect',
        zbkxzsclx: 'Market type not selectable',
        noSelectOpenFund: 'Cannot unselect wealth account',
        CashAccountTip: 'Use own funds for trading, no margin allowed.',
        MarginAccountTip: 'Also known as margin or leveraged account. Allows margin trading.',
        selectAccountToast: 'Select securities account type',
        zbzcqx: 'Hong Kong, US and A shares are enabled by default, cancellation not supported',
        zbzcqxCn: 'Hong Kong and US shares are enabled by default, cancellation not supported',
        derivativeRole: 'Derivatives Trading Permission',
        derivativeNoOpen: 'Opened',
        derivativeNoOpenTips: 'The options market requires derivative trading permission to be opened',
        derivativeOpenTips: 'The options market requires derivative trading permission to be opened, otherwise options trading cannot be conducted',
        derivativeOpenSuccess: 'Opened derivative trading permission',
        derivativeNoOpenError: 'Derivative trading permission not opened, cannot open options market.',
    },
    disclosure: {
        brdpoffxhlzq: 'My spouse is not a margin client of Fosun International Securities.',
        brhbrdpowygtkg: 'Neither I nor my spouse controls 35%+ voting rights of any Fosun International Securities margin client.',
        brbdblyfxzq: 'I do not represent another Fosun International Securities margin account.',
        brbmyyfxhl: 'I do not act for the same third party as another Fosun International Securities margin client.',
        brbsfxhldsysyr:
            'I am not the beneficial owner of any other Fosun International Securities margin account, nor do I benefit from or bear risks from its trades.',
        brmyxfxhllykhdb: 'I have not provided or received guarantees for another Fosun International Securities margin client.',
        brbmyyfxhllykhdbfz: 'I do not share a guarantor with another Fosun International Securities margin client.',
        brwbzhzzsyr: 'I am the ultimate beneficial owner of this account.',
        brhbzhdzzsyrwfzqcpr:
            'I or the ultimate beneficial owner is not a licensed representative or employee of a licensed corporation under Hong Kong SFO.',
        bryfxhlcprmyqqgx: 'I have no family relationship with Fosun International Securities licensed representatives or employees.',
        brhbrdygrsmycz:
            'I or my "associated persons" (including accounts of my minor children and accounts in which I have beneficial interest) do not operate/hold other accounts with Fosun International Securities.',
        brjpobbszygz:
            'I and/or my spouse, partner, children, parents or close relatives are not currently/formerly holding any important public office, e.g., head of state, senior politician, senior government official, senior executive or family/close associates of such persons (as defined in the Anti-Money Laundering and Counter-Terrorist Financing (Financial Institutions) Ordinance).',
        brbsmgjm: 'I am not a US resident, citizen or green card holder.',
        sfpl: 'Disclosure',
        rldsfyxxbyz: 'If your identity does not match the options, contact customer service for offline account opening.',
        yynymgsfzbzswfkh: 'If you are a US person, contact customer service for offline account opening.',
        yes: 'Yes',
        no: 'No',

        AML_title: 'AML Risk Notice',
        AML_des: 'Your name matches some AML cases, please read and confirm the following.',
        AML_pop1: 'I have not been arrested/tried/convicted/disciplined for any legal or regulatory violations.',
        AML_pop2: 'I am not involved in any litigation (civil/criminal), arbitration, government penalties, investigations or disputes.',
        AML_pop3:
            'I or my immediate family are not currently/formerly holding any important public office (including: head of state, senior politician, senior government official, senior judicial officer, senior military officer, senior party official, senior executive of a state-owned enterprise or religious leader) or political figure of an international org? See the Anti-Money Laundering and Counter-Terrorist Financing (Financial Institutions) Ordinance for details.',

        AML_tips: 'If you do not meet the conditions, contact customer service for offline account opening.',
        AML_que1:
            'Do you or your immediate family have any important public office (including: head of state, senior politician, senior government official, senior judicial officer, senior military officer, senior party official, senior executive of a state-owned enterprise or religious leader) or political figure of an international org?',
        AML_que2:
            'Have you been investigated or penalized by any financial regulatory agency (e.g., People’s Bank of China, China Securities Regulatory Commission, China Insurance Regulatory Commission, China Banking Regulatory Commission)?',
        AML_que3:
            'Have you been investigated/prosecuted/convicted for money laundering, financial crimes, terrorism financing or other illegal activities (criminal)?',
        AML_que4: 'Have you been listed by any government agency, regulatory agency or international organization?',
        AML_que_tips: 'If you do not meet the conditions, contact customer service for offline account opening.',
        AML_desc_error: 'Detailed description cannot be empty',
        AML_desc_placeholder: 'Please fill in the detailed description',
    },
    TaxInfo: {
        shuwuxinxi: 'Tax Info',
        shuwudiqu: 'Tax Region',
        shanchu: 'Delete',
        qxzgjhdq: 'Select Tax Country/Region',
        swgjdq: 'Tax Country/Region',
        qsrswbh: 'Enter Tax Number',
        swbh: 'Tax Number',
        tjxswxx: 'Add New Tax Info',
        xinxi: 'Info',
        qxzw8gjdq: 'Select W-8BEN Country/Region',
        w8gjdq: 'W-8BEN Country/Region',
        gjdq: 'Country/Region',
        qsryjjzdz: 'Enter Permanent Address',
        yjjzdz: 'Permanent Address',
        yiliaojie: 'Understood',
        brsmbrwxlsfzswjm: 'I declare I am a tax resident of the following jurisdictions.',
        qtxnwswjmssdsygx:
            'List all jurisdictions where you are a tax resident and the corresponding tax number (including Hong Kong). If unsure, consult your tax advisor.',
        rnsxgjm: 'For Hong Kong tax residents, the tax number is the HKID. For Chinese tax residents, it is the Chinese ID.',
        xmknwnzdtr: 'Info may be auto-filled. If incorrect, please re-enter.',
        qhdywzzdzzktxywpy: 'Verify English address, only English/Pinyin allowed.',
        zgnd: 'Mainland China',
        qrscgtswxxm: 'Confirm to delete this tax info?',
        swbhcf: 'Duplicate tax number, please re-enter.',
        swgdcf: 'Duplicate tax country/region, please re-select.',
        qtxnwyjjmssdswsfgxqjswbh: 'List the tax jurisdiction and number where you are a permanent resident.',
        upTitle: 'Upload File Proof',
    },
    W8popTipText: 'W8 country needs to be selected in the country of nationality or tax',
    填写须知: 'Fill in the notice',
    understand: 'Understood',
    Country: {
        qsrdqgjzss: 'Enter region keyword to search',
        cydq: 'Common Regions',
    },
    riskDisclosure: {
        fengxianpilu: 'Risk Disclosure',
        wqcmbgpjgzd: 'I understand stock price fluctuations can lead to losses or gains.',
        wqcmbkhxyzxcddzjyfx: 'I understand clients bear electronic trading risks and losses.',
        wyqcmbmgddjg: 'I understand US and overseas securities are regulated by local authorities, not HK SFC.',
        nbxwztwfxyp: 'You must listen to the full risk disclosure audio to proceed.',
        ypjzz: 'Audio loading',
        图片加载中: 'Image loading',
        yy: 'Cantonese',
        putonghua: 'Mandarin',
        wyjydjmb: 'I have read and understood',
        khxys: 'Client Agreement',
        nr: 'content;',
        cpdb: 'Licensed Rep:',
        pzh: 'License No.',
        bs: 'Speed',
        yue: 'About',
        fen: 'min',
        miao: 'sec',
        请点击下方播放按钮听取完整风险披露音频: 'Click to play the full risk disclosure audio.',
    },
    SignAgreement: {
        qianshuxieyi: 'Sign Agreement',
        wyydqb: 'I have read all',
        khwj: 'Account Opening Documents',
        yljxgfxbzy: ', understood the risks, and voluntarily open an account with Fosun Securities.',
        dianjiqianming: 'Click to sign',
        wqrystgdbrsyzljwzsyx:
            'I confirm the provided information is valid, true, complete, accurate, and up-to-date. I authorize Fosun Securities to verify the information and will notify promptly of any changes.',
        swzwzm: 'Tax Self-Certification',
        khxys: 'Client Agreement',
        gryxtk: 'Privacy Policy',
        yhdlxy: 'User Login Agreement',
        bzjzhcssqxy: 'Margin Account Standing Authorization',
        khsmjqr: 'Client Declaration',
        fybz: 'Fee Schedule',
        yiqueren: 'Confirmed',
        yProtocol1: 'I have read',
        yProtocol2: '《Asset Transfer Confirmation》',
        yProtocol3: ', agree to transfer assets from Yunfeng to Fosun Securities.',
        yProtocolTips: 'If you don’t agree, you need to submit an online transfer request after account opening.',
        goonSign: 'Continue Signing',
        pageTitle: 'Fosun Securities',
        dzqmf: 'Electronic Signature Law',
        wzsm: 'Perjury Statement',
        taxInfoAgreement: 'Tax Information and Pre-Withholding Agreement',
    },
    Signature: {
        qzfknhxqsndmz: 'Please sign your name horizontally in the box:',
        chongxie: 'Rewrite',
        wancheng: 'Complete',
        kehuqianming: 'Client Signature',
    },
    LivingWitness: {
        rlyz: 'Face Verification',
        qasldzpsydsmbrmbsp: 'Please follow the example to record a 3-second video of your face.',
        shili: 'Example',
        banshenzhengmian: 'Half-body front video',
        paishetishi: 'Shooting Tips',
        qbzmbwz: 'Ensure your face is fully visible with good lighting.',
        spschrbmykcxps: 'If unsatisfied, you can re-record after upload.',
        dqllqbbbzcsxtqqhllq: 'Current browser doesn’t support camera. Please switch browsers.',
        yzsbqcxyz: 'Verification failed. Please retry.',
        lzspsbqcxlz: 'Recording failed. Please retry.',
        qzydddkym: 'Please open this page on mobile.',
        rlyztg: 'Face verification passed.',
        spwjgdqcxsc: 'Video file too large. Please re-upload.',
        htsbtp: 'Liveness Detection Image',
        videoShortMsg: 'Video too short. Please re-upload.',
        videoLongMsg: 'Video too long. Please re-upload.',
    },
    CaApply: {
        zssq: 'Certificate Application',
        zlyjtxwbdjljck: 'Details completed. Click to view the account opening form.',
        wqrsq: 'I have read and agree',
        confirmAfterText:
            'Confirm application for Hong Kong-Mainland Mutual Recognition E-Certificate, and agree to use the certificate to sign the account opening form upon successful application.',
        yghrdzzs: 'Hong Kong-Mainland Mutual Recognition E-Certificate',
        sqcghtysyzs: ', and agree to use the certificate to sign the account opening form.',
        grkhsqb: 'Personal Account Opening Form',
        zwzmbg: 'Self-Certification Form (Personal)',
        pdfwjz: 'PDF file not loaded',
        rvckwjqdjysjzllqdk: 'To view the file, click the top right to open in browser.',
        wjjzz: 'File loading',
        wjjzsb: 'File loading failed',
    },
    OpenStatus: {
        ryyw: 'If you have any questions, please',
        bhyy: 'Rejection Reason',
        sm: 'Description',
        xingming: 'Name:',
        henglihao: 'Account No.:',
        lianxikefu: 'Contact Support',
        khzlshz: 'Account Opening Review in Progress',
        khzltbz: 'Account Opening Sync in Progress',
        yjydlrkt: 'We are accelerating the review, expected to complete within 1-2 working days',
        zlshbtgDesc: 'Please update or confirm information to continue account opening',
        khcgDesc: 'Thank you for your trust, let us start our wealth journey together',
        age65To75Tip:
            'Your account opening application has been submitted. If the information is correct, a customer service representative will contact you by phone within 1 business day to confirm the information. Please pay attention to answer the call.',
        zlshbtg: 'Not Passed',
        bckhzl: 'Supplement Documents',
        bczl: 'Supplement Info',
        khcg: 'Account Opened',
        gxkhcg: 'Congratulations on your account opening!',
        crzj: 'Deposit Funds',
        khsqytj: 'Account Opening Submitted',
        khqqtjsb: 'Submission Failed',
        lymcppsbl: 'Route Name Match Failed',
        shz: 'Reviewing',
        bh: 'Rejected',
        wc: 'Completed',
        redirecting: 'Redirecting',
    },
    home: {
        selectOpenAccountType: 'Select Type for Account Opening',
        hkTitle: 'set up online transfers',
        hkSubtitle: 'Transfer HKD 10,000 from Hong Kong bank account',
        planFile: 'Please prepare the following documents',
        PHK_IdcardFile: 'Overseas residents please provide passport, Hong Kong and Macau residents please provide ID card or passport',
        PHK_HZFile: 'Non-Mainland passport/ID card',
        PHK_AddressFileDesc: 'Document issued by designated institutions that includes your name and address',
        PHK_AddressFile: 'Address proof valid for 3 months',
        PHK_money: 'Hong Kong bank account',
        PHK_moneyDesc: `Transfer from a same-name Hong Kong bank account to FOSUN INTERNATIONAL for account opening
            verification, with a single deposit amount not less than HKD 10,000 equivalent`,

        cnTitle: 'CA Witnessed Account Opening',
        cnSubtitle: 'Mainland Chinese citizens holding overseas identity documents',
        PCN_HK: 'Hong Kong, Macao, or other overseas identity documents',
        PCN_HKDesc: 'Hong Kong, Macao, or other overseas identity documents',
        PCN_IdCard: 'Mainland China ID',
        PCN_IdCardDesc: 'Valid for more than 6 months, and aged 18 or above',
        PCN_BankCard: 'Mainland China bank card',
        PCN_BankCardDesc: 'For identity verification only, not applicable to deposits and withdrawals',
        No_OpenCnAccount: 'Sorry, we currently cannot open accounts for Mainland China investors.',

        bryydtykt: 'I agree to activate',
        dzjyfw: 'electronic trading services',
        bryydbty: 'I have read and agreed to',
        khxys: 'Client Agreement',
        xyb: 'Next',
        qh: 'Switch',
        changeCN: 'Open with Mainland China ID',
        changeHW: 'Open with Hong Kong/Macau ID or Passport (Non-Mainland)',
        changeCnOrHwBefor: ', current application will be invalid. Continue?',
        khsqtjsb: 'Account Opening Submission Failed',
        changeOpenAccount: 'Switch Account Type',
    },
    Step: {
        xxyz: 'Info Verification',
        fxpl: 'Risk Disclosure',
        rlyz: 'Face Verification',
        rjrz: 'Fund Verification',
    },
    UploadFile: {
        scz: 'Uploading...',
        jzz: 'Loading...',
        scsbqcs: 'Upload failed. Please retry.',
        xztp: 'Select Image',
    },
    fxhlkh: 'Fosun Securities Account Opening',
    AccountStatus: {
        xingming: 'Name:',
        henglihao: 'Account No.:',
        bhyy: 'Rejection Reason',
        lcjd: 'Process Node',
        khzlshz: 'Account Opening Review in Progress',
        khzlxg: 'Documents',
        btg: 'Not Passed',
        zlshytg: 'Review',
        ytg: 'Passed',
        ljxg: 'Update Now',
        crzj: 'Deposit Funds',
        bckhzl: 'Supplement Documents',
        zjdzqrz: 'Fund Confirmation in Progress',
        zjdzyc: 'Fund',
        yc: 'Failed',
        zjydz: 'Funds Deposited',
        ydz: 'Confirmed',
        jxcrzj: 'Continue Deposit',
        zrgp: 'Transfer Stocks',
        lxkf: 'Contact Support',
        yjydlrkt: 'We are accelerating the review, expected to complete within 1-2 working days',
        qqrhxgqrxxyjxwckh: 'Please update or confirm info to proceed.',
        khcg: 'Account Opened',
        zwrjqtjrj: 'No funds deposited. Please deposit.',
        ljrj: 'Deposit Now',
        zcsqqrz: 'Transfer Request Confirmation in Progress',
    },
    hk_IDcard: {
        xgjmsfz: 'Hong Kong ID',
        amjmsfz: 'Macau ID',
        huzhao: 'Passport (Non-Mainland)',
        man: 'Male',
        woman: 'Female',
        sfxxyz: 'Identity Verification',
        sfxxjyykh: 'Identity info is only for account opening. We will protect your privacy.',
        guojidiqu: 'Nationality (Region)',
        brssxgdyjjm: 'I am a permanent resident of the selected nationality (region).',
        qxzgjdq: 'Please select nationality (region).',
        khtips: 'Tip: HK/Macao/Overseas passport cannot be used as account opening ID.',
        zjlx: 'ID Type',
        qxzzjlx: 'Please select ID type.',
        qfgjdq: 'Issuing Country/Region',
        qxzqfgjdq: 'Please select issuing country/region.',
        zjhm: 'ID Number',
        qsrzjhm: 'Please enter ID number.',
        szhzm: 'Number or letter',
        xgjmsfzwxsrkh: 'Hong Kong ID: No brackets, e.g., A1234567',
        证件号码格式错误: 'Invalid ID number format.',
        qsrzjhm: 'Please enter ID number.',
        scsfz: 'Upload ID',
        qscjmsfz: 'Click to upload ID or passport photo.',
        scszgjyjjmsfz: 'Upload permanent resident ID or passport.',
        qscyjzjxx: 'Please fill in your permanent resident ID information.',
        qscsfzjrxm: 'Upload ID photo. Mainland China ID requires both sides.',
        MO_qscsfzjrxm: 'Upload ID photo. Mainland China and Macau IDs require both sides.',
        zgxg: 'Hong Kong',
        zgam: 'Macau',
        gsfzykhhsqkhz: 'This ID is already in use. Please log in with the original account.',
        sjh: 'Phone Number',
        rgnwjyzhdmm: 'If you forgot the password, use the phone number to reset. For help, please',
        tjxxsb: 'Submission Failed',
        qxxzgqdq: 'Please select nationality (region) first.',
        sxgj: 'Selected nationality (region) requires',
        jxxxkh: 'offline account opening.',
        chIdCard: 'ID',
        chPassport: 'Mainland Passport',
        chPassportError: 'Mainland Passport format error',
    },
    hk_ProofAddress: {
        dzzm: 'Address Proof',
        dzzmlxbksdtzd: 'Address proof includes utility bills, telecom, credit card statements, etc.',
        jzgjdq: 'Residence Country/Region',
        qxzjzgjdq: 'Please select residence country/region.',
        jzcs: 'Residence City',
        qtxjzcs: 'Please enter residence city.',
        xxdz: 'Detailed Address',
        qtxxxdz: 'Please enter detailed address.',
        qwztxjdldlc: 'Please fill in the full address, matching the proof.',
        zzdzytxdzxt: 'Residential address matches mailing address.',
        rzzdzytxdzbt: 'If different, please contact us for offline account opening.',
        scdzzm: 'Upload Address Proof',
        scsl: 'Upload Example',
        dzzmyxqzsgyn: 'Address proof must be valid within 3 months.',
        grxmrqjdzxxxwz: 'Full name, date, and address info must be complete.',
        scyjdzb: 'Upload original, photo, or scanned copy.',
        qwscpsddnpmzp: 'Do not upload screenshots. Ensure the proof is complete and uncropped.',
        qscdzzm: 'Click to upload address proof.',
        qqrndzzdzydzzmwqyz: 'Ensure your residential address matches the proof to avoid delays.',
        zzdz: 'Residential Address:',
    },
    hk_UserInfo: {
        grxxtx: 'Personal Info',
        sfxxjyykh: 'Identity info is only for account opening. We will protect your privacy.',
        qsrxm: 'Please enter Chinese name.',
        ywxm: 'English Name',
        xm: 'Chinese Name',
        xing: 'Please enter English surname.',
        ming: 'Please enter English given name.',
        xingbie: 'Gender',
        csrq: 'Date of Birth',
        csdd: 'Place of Birth',
        qxzxb: 'Please select gender.',
        qxzcsrq: 'Please select date of birth.',
        qxzcsdd: 'Please select place of birth.',
        qsrnddzyxdz: 'Please enter your email.',
        dzyxdz: 'Email',
        jdjsfs: 'Statement Delivery',
        dzyj: 'Email',
        jdyy: 'Statement Language',
        xzcsd: 'Select Place of Birth',
        ylj: 'Understood',
        lxkf: 'Contact Support.',
        zgdlshs: 'Shanghai',
        qsrzqddzyxdz: 'Please enter a valid email.',
        man: 'Male',
        woman: 'Female',
        s8syxzbzc: 'Users under 18 cannot open accounts.',
        l5syszbzc: 'Users over 65 cannot open accounts.',
        ftzw: 'Traditional Chinese',
    },
    transitionGold: {
        dqjd: 'Current Progress',
        zlytj1: 'Documents submitted. Deposit funds to verify identity and proceed.',
        zlytj2: 'Documents submitted. Deposit funds/transfer stocks to proceed.',
        xzrjbz: 'Select Deposit Currency',
        zcgymy: 'Supports HKD, USD, and CNH deposits.',
        rjfxhl: 'Deposit to Fosun Securities account.',
        db: 'Single transfer',
        zzfxhl: 'Transfer to Fosun International Securities bank account shall not be less than the equivalent of',
        gangyuan: 'HKD',
        tzfxhlsk: 'Notify Fosun Securities of receipt.',
        xxzzhxtzfxhl: 'Notify Fosun Securities after offline transfer.',
        crzj: 'Deposit Funds',
        zrgp: 'Transfer Stocks',
    },
    C_SearchCompany: {
        noSearch: 'No company found?',
        searchNoData: 'No results found.',
        inputCompanyInfo: 'Enter Company Info',
    },
    openAccountStrictContent: {
        confirmButtonText: 'Switch Account Type',
        tip1: 'Sorry, we currently cannot open accounts for Mainland China investors. Please proceed with online transfer.',
        tip2: 'Sorry, we currently cannot open accounts for Mainland China investors.',
        tip3: 'Note: Switching account types will invalidate your current application.',
        tip4: 'Upload ID photo. Mainland China investors cannot open accounts.',
        tip5: 'Please proceed with account opening on the Star Wealth app.',
        tip6: 'Please enable location access to proceed.',
        gotoAppBtn: 'Go Now',
        gotoSettingBtn: 'Go to Settings',
        getAppLocationToastMessage: 'Fetching...',
    },
    mrStatus: {
        tip: {
            span1: 'System maintenance is in progress to improve experience.',
            span2: 'System Maintenance',
            span3: '. Account opening, fund transfers, forex, and order submissions may be affected. Account balances, holdings, and transaction history may also be unavailable. We apologize for any inconvenience.',
        },
    },
    statement: {
        '抱歉，当前区域为受限制区域，需提供其他香港券商或银行的账户结单才可继续开户。':
            'Sorry, this region is restricted. Provide a statement from another HK broker or bank to proceed.',
        现有香港市场账户信息: 'Existing HK Market Account Info',
        '开户券商/银行': 'Broker/Bank',
        请选择开户券商或银行: 'Please select broker or bank.',
        '其他开户券商/银行': 'Other Broker/Bank',
        '请填写其他开户券商/银行名称': 'Please enter other broker/bank name.',
        开户姓名: 'Account Name',
        请填写开户姓名: 'Please enter account name.',
        账户号码: 'Account Number',
        请填写账户号码: 'Please enter account number.',
        上传证明文件: 'Upload Proof',
        '证明文件支持图片、PDF，需为6个月以内香港券商/香港银行的完整结单，应包含券商/银行名称及账号信息。':
            'Proof supports images/PDFs. Must be a complete statement from HK broker/bank within 6 months, including broker/bank name and account info.',
        '常用券商/银行名称': 'Common Broker/Bank Names',
        '找不到您要的券商/银行？可添加': 'Can’t find your broker/bank? Add',
        其他: 'Other',
        brokerName: 'Please enter broker/bank name.',
        '当前区域为受限制区域，需提供其他香港券商或香港银行的账户结单才可继续开户。':
            'This region is restricted. Provide a statement from another HK broker or bank to proceed.',
        结单示例: 'Statement Example',
        稍后提交: 'Submit Later',

        documentNotAvailable: 'Not your document at hand?',
        laterSupplement: 'Supplement later',
        uploadOverseasID: 'Please upload your Hong Kong/Macao or overseas identity document information',
        fileRequirements: 'File Requirements',
        uploadDocumentFrontBack: 'Upload the original front/back of overseas identity document.',
        supportedFileFormats: 'Proof documents are only supported in image format.',
        needHoldOverseasID: 'Need to provide proof of working or living overseas',
        photoInstruction:
            'When taking the photo, please ensure the phone is held horizontally, the document borders are complete, the text is clearly visible, and the lighting is even without glare.',
        uploadOverseasIDPhoto: 'Please upload a photo of your Hong Kong, Macao, or overseas identity document',
    },
    promptText: 'System detected an incomplete corporate account opening task. Please proceed on the web version.',

    changeChannel: {
        title: 'Confirmation',
        confirmButtonText: 'Confirm Change',
        cancelButtonText: 'No Change Needed',
        content1: 'Current referral code is',
        content2: ', different from your stored code',
        content3: '. Confirm to update to the latest code',
        content4: '. For help, contact your account manager.',
        incorrectChannel: 'Update failed. Referral code not found. Contact your account manager.',
    },
}
